module.exports = __webpack_public_path__ + "img/rawdacious.c7136959.png";